import React from "react";
import {connect} from 'dva';
import {framework_tool,component_tool, utils_tool} from '../../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport} = component_tool
let {Session} = utils_tool

const _getValue = (type, key) => {
  const values = {
      state: {
          '0': '无效',
          '1': '有效',
      },
      baseType: {
        '0': '否',
        '1': '是',
      }
  }
  return values[type][key] || ''
}

class LabelUser extends WizContainer {
  componentName = 'labelUser'

  constructor(props) {
    super(props);
    this.state = {}
    const {history} = props
    let labelInfo = {}
    if (history.location && history.location.pathname === '/biz/label/labelUser') {
      if (history.location && history.location.record) {
        labelInfo = history.location.record
        Session.set('labelInfo', labelInfo)
      } else {
        labelInfo = Session.get('labelInfo') || {}
      }
    }
    this.labelInfo = labelInfo
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnSelf = {cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    }}
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标签名称',
        field: 'labelName',
        width: 20,
        columnSelf
      },
      {
        headerName: '标签编码',
        field: 'labelCode',
        width: 20,
        columnSelf
      },
      {
        headerName: '标签状态',
        field: 'labelState',
        width: 15,
        columnSelf
      },
      {
        headerName: '学员账号',
        field: 'userName',
        width: 20,
        columnSelf
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        width: 20,
        columnSelf
      },
      {
        headerName: '任职信息',
        field: 'identityLists',
        width: 40,
        columnSelf
      },
      {
        headerName: '贴标时间',
        field: 'operationTime',
        width: 20,
        columnSelf
      },
      {
        headerName: '是否推送课程',
        field: 'pushType',
        width: 15,
        columnSelf
      },
      {
        headerName: '是否完成课程',
        field: 'completeType',
        width: 15,
        columnSelf
      },
      {
        headerName: '完成时间',
        field: 'completeTime',
        width: 20,
        columnSelf
      },
      {
        headerName: '是否撕除标签',
        field: 'tearType',
        width: 15,
        columnSelf
      },
      {
        headerName: '用户贴标状态',
        field: 'state',
        width: 15,
        columnSelf
      },
    ]
    if(o['success']){
      let data = o['data']
      data && data.forEach(d => {
        d.labelState = _getValue("state", d.labelState)
        d.pushType = _getValue("baseType", d.pushType)
        d.completeType = _getValue("baseType", d.completeType)
        d.tearType = _getValue("baseType", d.tearType)
        d.state = _getValue("state", d.state)
        d.identityLists = d.identityLists && d.identityLists.map(t => t.orgName + '-' + t['positionName']).join(',') || ''
      })
      WizBrowserExport({
        title: '标签用户信息',
        sheetName: '标签用户信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '标签用户信息.xlsx'
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getPushProps = () => {
    let { location } = this.props;
    let labelInfo = location['record'] && location['record'] ? location['record'] : undefined
    if (!labelInfo) {
      labelInfo = this.labelInfo;
    }
    return labelInfo
  }

  _render() {
    let pushProps = this._getPushProps()
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({pushProps}),
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile
      },
      labelId: pushProps && pushProps.id
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(LabelUser);
